import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FooterButtonComponent } from './footer-button';

@NgModule({
  declarations: [FooterButtonComponent],
  imports: [IonicPageModule.forChild(FooterButtonComponent)],
  exports: [FooterButtonComponent]
})
export class FooterButtonComponentModule {}



// WEBPACK FOOTER //
// ./src/components/myria/footer-button/footer-button.module.ts